<template>
  <div class="bg-white">
    <div class="p-6">
      <p class="font-bold text-lg mb-6">Info</p>
      <div class="flex justify-start items-start gap-6">
        <div class="w-1/5">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">ID</label>
          <TextField v-if="isCostMappingEditMode" type="text" disabled v-model="costMappingDetail.id" />
          <p v-else class="text-neutral-500 break-all">{{ costMappingDetail.id }}</p>
        </div>
        <div class="w-4/5">
          <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Cost Mapping</label>
          <TextField v-if="isCostMappingEditMode" type="text" v-model="name" />
          <p v-else class="text-neutral-500">{{ costMappingDetail.name }}</p>
        </div>
      </div>
    </div>
    <div class="p-6 shadow-border-b">
      <div class="flex justify-between items-center gap-6 mb-6">
        <p class="font-bold text-lg">Base Cost</p>
        <span class="inline-flex justify-center items-center gap-2 cursor-pointer" @click="toggleCostMappingModal()">
          <CirclePlus color="primary-500" width="22" height="22" />
          <span class="text-primary-500 text-base">Tambah</span>
        </span>
      </div>
      <div class="list relative">
        <div v-if="filteredData?.length === 0" class="empty text-neutral-400 absolute left-1/2 top-1/2 transform -translate-y-1/2 -translate-x-1/2">
          Belum terdapat base cost, silakan klik tombol tambah
        </div>
        <template v-else>
          <TableComponent :columns="columns" :list="filteredData">
            <template slot="table-row" slot-scope="{ entry, column, index }">
              <div v-if="column.field === 'action'" class="flex gap-3">
                <span class="inline-block cursor-pointer" @click="editBaseCost(entry.id)"><Pencil color="neutral-700"/></span>
                <span class="inline-block cursor-pointer" @click="toggleDeleteConfirmation(entry.id)"><Trash color="neutral-700"/></span>
              </div>
              <span class="block break-all" v-else-if="column.field === 'id'" :title="entry.id">
                {{ entry.id }}
              </span>
              <span class="block" v-else-if="column.field === 'no'">
                {{ index + 1 }}
              </span>
              <span class="block" v-else-if="fieldWithCurrencyFormat.indexOf(column.field) > -1">
                {{ entry[column.field] | currencyFormat }}
              </span>
              <span v-else>{{ entry[column.field] }}</span>
            </template>
          </TableComponent>
          <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
            <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize" @onPageChange="onPageChange" />
          </div>
        </template>
      </div>
    </div>
    <div class="flex justify-end gap-6 p-6">
      <Button buttonText="Hapus" type="delete" :icon="() => import('@/components/Icons/Trash')" @action="toggleCMDeleteConfirmation()" :size="isMobile ? 'full' : 'regular'" />
      <Button v-if="isCostMappingEditMode" buttonText="Simpan" type="primary" @action="save()" :size="isMobile ? 'full' : 'regular'" />
    </div>
    <Modal :modalVisible="visibleCostMappingModal" @close="toggleCostMappingModal()" width="600px" id="cost-mapping-modal">
      <template slot="modal-content">
        <CostMappingForm :isEditMode="isEditMode" :baseCostId="selectedBaseCostId" @close="toggleCostMappingModal()" @refetch="refetch()" :costMappingId="costMappingId" :partnerId="partnerId" />
      </template>
    </Modal>
    <Modal :modalVisible="visibleEditConfirmation" @close="toggleEditConfirmation()" width="600px" id="edit-confirmation-modal">
      <template slot="modal-content">
        <div class="flex items-center justify-start gap-6 mb-6">
          <span class="flex-shrink-0"><Alert color="neutral-700"/></span>
          <div class="flex-col flex gap-2 items-start">
            <p class="text-2xl font-bold">Peringatan</p>
            <p class="text-sm text-neutral-500 text-left">
              Data perubahan di update dalam mapping cost ini akan berpengahrus pada layanan yang telah tekoneksi dengan mapping cost ini. pastikan base cost dan harga sudah sesuai.
            </p>
          </div>
        </div>
        <div class="flex justify-end gap-6">
          <Button buttonText="Batal" type="secondary" @action="toggleEditConfirmation()" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Lanjutkan" type="primary" @action="confirmEdit()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
    <Modal :modalVisible="visibleDeleteConfirmation" @close="toggleDeleteConfirmation()" width="600px" id="delete-confirmation-modal">
      <template slot="modal-content">
        <div class="flex items-center justify-start gap-6 mb-6">
          <span class="flex-shrink-0"><Alert color="neutral-700"/></span>
          <div class="flex-col flex gap-2 items-start">
            <p class="text-2xl font-bold">Hapus Base Cost?</p>
            <p class="text-sm text-neutral-500 text-left">
              Apakah Anda yakin untuk menghapus base cost ini?
            </p>
          </div>
        </div>
        <div class="flex justify-end gap-6">
          <Button buttonText="Tidak" type="secondary" @action="toggleDeleteConfirmation()" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Ya" type="primary" @action="confirmDelete()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
    <Modal :modalVisible="visibleCMDeleteConfirmation" @close="toggleCMDeleteConfirmation()" width="600px" id="delete-confirmation-modal">
      <template slot="modal-content">
        <div class="flex items-center justify-start gap-6 mb-6">
          <span class="flex-shrink-0"><Alert color="neutral-700"/></span>
          <div class="flex-col flex gap-2 items-start">
            <p class="text-2xl font-bold">Hapus Cost Mapping?</p>
            <p class="text-sm text-neutral-500 text-left">
              Menghapus cost mapping akan berpengaruh terhadap layanan dan tidak bisa dibisa di kembalikan. pastikan cost mapping yang akan di buat tidak terkoneksi dengan layanan apapun
            </p>
          </div>
        </div>
        <div class="flex justify-end gap-6">
          <Button buttonText="Tidak" type="secondary" @action="toggleCMDeleteConfirmation()" :size="isMobile ? 'full' : 'regular'" />
          <Button buttonText="Ya" type="primary" @action="confirmCMDelete()" :size="isMobile ? 'full' : 'regular'" />
        </div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { currencyFormat } from '@/util'
export default {
  filters: {
    currencyFormat
  },
  components: {
    TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    CostMappingForm: () => import(/* webpackChunkName: "CostMappingForm" */ '@/views/Package/CostMappingForm'),
    Modal: () => import('@/components/Modal/Modal'),
    Button: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/Button'),
    CirclePlus: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/CirclePlus'),
    Trash: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Trash'),
    Pencil: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Pencil'),
    Alert: () => import(/* webpackChunkName: "icon" */ '@/components/Icons/Alert'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data() {
    return {
      searchTerm: '',
      totalRecords: 0,
      currentPage: 1,
      pageSize: 100,
      fieldWithCurrencyFormat: ['cost_per_weight', 'cost_volume_small', 'cost_volume_medium', 'cost_volume_large'],
      fieldWithCityName: ['origin_city', 'destination_city'],
      columns: [
        { label: 'No', field: 'no' },
        { label: 'Kota Asal', field: 'origin_city_name' },
        { label: 'Kota Tujuan', field: 'destination_city_name' },
        { label: 'Komponen Harga', field: 'cost_per_weight' },
        { label: 'Dimensi Kecil', field: 'cost_volume_small' },
        { label: 'Dimensi Menengah', field: 'cost_volume_medium' },
        { label: 'Dimensi Besar', field: 'cost_volume_large' },
        { label: 'Action', field: 'action' }
      ],
      visibleCostMappingModal: false,
      visibleEditConfirmation: false,
      visibleDeleteConfirmation: false,
      visibleCMDeleteConfirmation: false,
      selectedBaseCostId: null,
      isEditMode: false,
      name: null
    }
  },
  computed: {
    ...mapGetters('auth', ['userData']),
    ...mapGetters('partner', ['costMappingDetail', 'baseCost']),
    ...mapGetters('common', ['isMobile']),
    ...mapGetters('master', ['cities']),
    partnerId() {
      return this.userData?.user?.group_id
    },
    costMappingId() {
      return this.$route.params.id
    },
    filteredData() {
      let temp = this.baseCost || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.perPage + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.perPage + this.perPage
      return lastOnPage > this.total ? this.total : lastOnPage
    },
    isCostMappingEditMode() {
      return this.$route?.meta?.mode === 'edit'
    }
  },
  async created() {
    await this.getCityList()
    this.getCostMappingInfo()
    this.getBaseCostInfo()
  },
  methods: {
    ...mapActions('partner', ['getCostMappingDetail', 'getBaseCost', 'removeBaseCost', 'removeCostMapping', 'updateCostMapping']),
    ...mapActions('common', ['showLoading', 'hideLoading', 'setToast']),
    ...mapActions('master', ['getCities']),
    save() {
      this.showLoading()
      this.updateCostMapping({
        partnerId: this.partnerId,
        costMappingId: this.costMappingId,
        payloads: {
          cost_mapping_name: this.name
        }
      }).then(() => {
        this.hideLoading()
        this.setToast({
          options: {
            type: 'success',
            duration: 1000,
            primaryText: 'Berhasil Mengubah Cost Mapping',
            secondaryText: 'Data telah kami simpan',
            callback: this.handleCallback
          }
        })
      })
    },
    handleCallback() {
      this.$router.push('/package/cost-mapping')
    },
    toggleCMDeleteConfirmation() {
      this.visibleCMDeleteConfirmation = !this.visibleCMDeleteConfirmation
    },
    toggleDeleteConfirmation(id = null) {
      this.visibleDeleteConfirmation = !this.visibleDeleteConfirmation
      if (!this.visibleDeleteConfirmation) {
        this.selectedBaseCostId = null
      } else {
        this.selectedBaseCostId = id
      }
    },
    confirmCMDelete() {
      this.showLoading()
      this.removeCostMapping({
        partnerId: this.partnerId,
        costMappingId: this.costMappingId
      })
        .then(() => {
          let self = this
          this.hideLoading()
          this.toggleCMDeleteConfirmation()
          this.setToast({
            options: {
              type: 'success',
              duration: 1000,
              primaryText: 'Berhasil Menghapus Cost Mapping',
              secondaryText: 'Data telah kami simpan',
              callback: () => {
                self.$router.push('/package/cost-mapping')
              }
            }
          })
        })
        .catch(error => {
          this.hideLoading()
          this.toggleCMDeleteConfirmation()
          this.setToast({
            options: {
              type: 'danger',
              duration: 5000,
              primaryText: 'Gagal Menghapus Cost Mapping',
              secondaryText: error.response.data.message,
              callback: () => {
                this.$router.push('/package/cost-mapping')
              }
            }
          })
        })
    },
    confirmDelete() {
      this.showLoading()
      this.removeBaseCost({
        partnerId: this.partnerId,
        costMappingId: this.costMappingId,
        baseCostId: this.selectedBaseCostId
      }).then(() => {
        let self = this
        this.hideLoading()
        this.toggleDeleteConfirmation()
        this.setToast({
          options: {
            type: 'success',
            duration: 1000,
            primaryText: 'Berhasil Menghapus Base Cost',
            secondaryText: 'Data telah kami simpan',
            callback: () => {
              self.getBaseCostInfo()
            }
          }
        })
      })
    },
    confirmEdit() {
      this.visibleEditConfirmation = false
      this.$nextTick(() => {
        this.toggleCostMappingModal()
      })
    },
    toggleEditConfirmation() {
      this.visibleEditConfirmation = !this.visibleEditConfirmation
      if (!this.visibleEditConfirmation) {
        this.resetData()
      }
    },
    editBaseCost(id) {
      this.isEditMode = true
      this.selectedBaseCostId = id
      this.toggleEditConfirmation()
    },
    resetData() {
      this.isEditMode = false
      this.selectedBaseCostId = null
    },
    toggleCostMappingModal() {
      this.visibleCostMappingModal = !this.visibleCostMappingModal
      if (!this.visibleCostMappingModal) {
        this.resetData()
      }
    },
    getCityList() {
      this.getCities({
        params: {
          page: 1,
          per_page: 1000,
          search_keyword: ''
        }
      })
    },
    async refetch() {
      await this.toggleCostMappingModal()
      this.getBaseCostInfo()
    },
    getBaseCostInfo() {
      this.getBaseCost({
        partnerId: this.partnerId,
        costMappingId: this.costMappingId,
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          search_keyword: '',
          sort: 'DESC'
        }
      }).then(res => {
        this.totalRecords = res.data.meta.total_item
      })
    },
    getCostMappingInfo() {
      this.showLoading()
      this.getCostMappingDetail({
        partnerId: this.partnerId,
        costMappingId: this.costMappingId
      }).then(res => {
        this.hideLoading()
        if (this.isCostMappingEditMode) {
          this.name = res.data.data.name
        }
      })
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/package/cost-mapping', query: { page: page } })
    },
    getCityName(code) {
      return this.cities.filter(item => item.code === code)[0]?.name
    }
  }
}
</script>

<style lang="scss" scoped>
.list {
  min-height: 480px;
}
</style>
